import { jwtDecode } from "jwt-decode";

export interface DecodedToken {
  exp: number;
  iat: number;
  [key: string]: any;
}

export const isTokenExpired = (token: string): boolean => {
  try {
    const decoded: DecodedToken = jwtDecode(token);
    const currentTime = Date.now() / 1000;
    return decoded.exp < currentTime;
  } catch (error) {
    console.error("Error decoding token:", error);
    return true;
  }
};

export const getTokenExpiryTime = (token: string): number | null => {
  try {
    const decoded: DecodedToken = jwtDecode(token);
    return decoded.exp;
  } catch (error) {
    console.error("Error decoding token:", error);
    return null;
  }
};

export const getTimeUntilExpiry = (token: string): number | null => {
  const expiryTime = getTokenExpiryTime(token);
  if (!expiryTime) return null;

  const currentTime = Date.now() / 1000;
  return Math.max(0, expiryTime - currentTime);
};
